// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/routes/resources.request.tsx"
);
import.meta.hot.lastModified = "1740183864618.5168";
}
// REMIX HMR END

import { ActionFunctionArgs } from "@remix-run/cloudflare";
import { makeDomainFunction } from "domain-functions";
import { z } from "zod";
import { formAction } from "~/components/forms/form-action.server";
import { sendContactRequest } from "~/services/airtable.server";
import { checkHoneypot } from "~/utils/honeypot.server";

export const schema = z.object({
  email: z.string().min(1, { message: "This field is required." }).email({
    message: "Write a valid email.",
  }),
  name: z
    .string()
    .min(1, {
      message: "This field is required.",
    })
    .min(3, {
      message: "Please use at least 3 characters.",
    }),
  companyName: z.string().min(1, { message: "This field is required." }),
  interestedIn: z
    .enum([
      "I’m interested in",
      "Decoupled Architectures",
      "Custom Web App Development",
      "Drupal Digital Experiences",
      "Quality Assurance (QA)",
      "Web Accessibility",
      "Audit SEO & Performance",
      "DevOps",
      "E-commerce",
      "Other",
    ])
    .default("I’m interested in")
    .refine((value) => value !== "I’m interested in", {
      message: "Please select an option.",
    }),
  comments: z.string().optional(),
});

const environmentSchema = z.object({
  AIRTABLE_API_KEY: z.string(),
  AIRTABLE_BASE_ID: z.string(),
});

const mutation = makeDomainFunction(
  schema,
  environmentSchema
)(async ({ companyName, interestedIn, comments, email, name }, context) => {
  await sendContactRequest(
    {
      companyName,
      comments,
      interestedIn,
      email,
      name,
    },
    context as any
  );

  return {
    success: true,
  };
});

export const action = async ({
  request,
  context: environment,
}: ActionFunctionArgs) => {
  const formData = await request.clone().formData();
  await checkHoneypot(formData, environment.HONEYPOT_SEED as string);

  return await formAction({
    request,
    schema,
    mutation,
    environment,
  });
};
